import { ArrowDownLeft, ArrowUpRight } from "lucide-react";
import type { CashDirection } from "../../../shared/money";

export default function CashDirectionPicker({ value, onChange }: { value: CashDirection; onChange: (value: CashDirection) => void }) {
  return <fieldset className="cash-direction-picker"><legend>Money type</legend><div>
    <button type="button" className={value === "expense" ? "active expense" : ""} aria-pressed={value === "expense"} onClick={() => onChange("expense")}><ArrowUpRight/><span><strong>Expense</strong><small>Money going out</small></span></button>
    <button type="button" className={value === "income" ? "active income" : ""} aria-pressed={value === "income"} onClick={() => onChange("income")}><ArrowDownLeft/><span><strong>Income</strong><small>Money coming in</small></span></button>
  </div></fieldset>;
}
